import $api from "../http";
import {
  IUpdateUserSubscriptionCancellationReasonModel,
  IUserSubscriptionModel,
} from "../models/UserSubscription";

class UserSubscriptionServiceClass {
  async getUserSubscriptionByUserId(userId: string | null) {
    return await $api.get<IUserSubscriptionModel | null>(
      `api/user-subscription/get-by-userId/${userId}`
    );
  }

  async getUserSubscriptionCancellationReasonKeys() {
    return await $api.get<{ keys: string[] }>(`api/user-subscription/cancellation-reason/keys`);
  }

  async updateUserSubscriptionCancellationReason(
    userSubscriptionId: string,
    model: IUpdateUserSubscriptionCancellationReasonModel
  ) {
    return await $api.put<{}>(
      `api/user-subscription/cancellation-reason/update/${userSubscriptionId}`,
      model
    );
  }
}

export const UserSubscriptionService = new UserSubscriptionServiceClass();
